// --- React & Redux
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// --- Actions & Hooks
import { logout } from "../../store/auth";
// --- External UI Libraries
import NavBar, { Brand, Utility, NavBarMenu } from "@dtci/spellbook/NavBar";
// --- Utilities
import { resetActiveUser } from "../../utils/localStorageService";
// --- Config
import { current_env } from "../../config/constants";
import logoImg from "../../../shared/assets/img/logo.png";
// --- Styles
import "./Header.scss";

/**
 * Header component for the application.
 * Displays the app name and a logout button.
 *
 * @returns {JSX.Element} The rendered Header component.
 */
export const Header = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((s) => s.auth);
  const navigate = useNavigate();

  // Handles the user logout process
  async function handleLogout() {
    resetActiveUser();
    await dispatch(logout());
    navigate("/login");
  }

  function handleKeyPress(event) {
    if (event.key === "Enter") {
      handleLogout();
    }
  }

  // Parses the user's email to extract their name.
  const parseName = (email = "") => {
    const [firstName, lastName] = email.split("@")[0].split(".");
    return `${firstName} ${lastName ?? ""}`;
  };

  return (
    <NavBar style={{ background: "#3611c8" }}>
      <Brand
        logoSrc={logoImg}
        text={
          <>
            TAP&nbsp;
            {current_env && (
              <span
                style={{
                  background: "#B8B8FF",
                  color: "#3611c8",
                  borderRadius: 4,
                  padding: "0 4px",
                }}
              >
                {current_env}
              </span>
            )}
          </>
        }
      />
      <>
        <Utility>
          <NavBarMenu>
            {user && (
              <button onKeyDown={handleKeyPress} onClick={handleLogout}>
                Logout, {parseName(user)}
              </button>
            )}
          </NavBarMenu>
        </Utility>
      </>
    </NavBar>
  );
};
